/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ManagerInfo } from './';
import {
    ManagerInfoFromJSON,
    ManagerInfoFromJSONTyped,
    ManagerInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface InvitationContextResponseEnterpriseManagers
 */
export interface InvitationContextResponseEnterpriseManagers {
    /**
     * 
     * @type {ManagerInfo}
     * @memberof InvitationContextResponseEnterpriseManagers
     */
    salesManager?: ManagerInfo;
    /**
     * 
     * @type {ManagerInfo}
     * @memberof InvitationContextResponseEnterpriseManagers
     */
    csmManager?: ManagerInfo;
    /**
     * 
     * @type {ManagerInfo}
     * @memberof InvitationContextResponseEnterpriseManagers
     */
    finopsManager?: ManagerInfo;
}

/**
 * Check if a given object implements the InvitationContextResponseEnterpriseManagers interface.
 */
export function instanceOfInvitationContextResponseEnterpriseManagers(value: object): value is InvitationContextResponseEnterpriseManagers {
    return true;
}

export function InvitationContextResponseEnterpriseManagersFromJSON(json: any): InvitationContextResponseEnterpriseManagers {
    return InvitationContextResponseEnterpriseManagersFromJSONTyped(json, false);
}

export function InvitationContextResponseEnterpriseManagersFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponseEnterpriseManagers {
    if (json == null) {
        return json;
    }
    return {
        
        'salesManager': json['salesManager'] == null ? undefined : ManagerInfoFromJSON(json['salesManager']),
        'csmManager': json['csmManager'] == null ? undefined : ManagerInfoFromJSON(json['csmManager']),
        'finopsManager': json['finopsManager'] == null ? undefined : ManagerInfoFromJSON(json['finopsManager']),
    };
}

export function InvitationContextResponseEnterpriseManagersToJSON(value?: InvitationContextResponseEnterpriseManagers | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'salesManager': ManagerInfoToJSON(value['salesManager']),
        'csmManager': ManagerInfoToJSON(value['csmManager']),
        'finopsManager': ManagerInfoToJSON(value['finopsManager']),
    };
}

